// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const shroomish: PokeData = {
  "id": 285,
  "name": "shroomish",
  "height": 4,
  "weight": 45,
  "base_experience": 59,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "absorb",
    "mega-drain",
    "leech-seed",
    "growth",
    "poison-powder",
    "stun-spore",
    "toxic",
    "spore",
    "giga-drain",
    "worry-seed",
    "seed-bomb"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "poison-powder",
    "stun-spore",
    "branch-poke",
    "bullet-seed",
    "solar-beam",
    "overgrowth",
    "vine-whip",
    "power-whip",
    "wood-hammer",
    "frenzy-plant",
    "razor-leaf"
  ],
  "evolution_chain": {
    "id": 142,
    "item": null,
    "species": [
      {
        "name": "shroomish",
        "order": 311,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "breloom",
        "order": 312,
        "types": [
          PokeType.GRASS,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 285,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 23,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 60,
    "speed": 35,
    "ability_power": 40
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
